export default __webpack_public_path__ + "static/affordable-and-clean-energy-1e6e202574124f3d9c3ff056b6a9b60c.png";